import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Page = styled.div`
  min-height: 100vh;
  background: #0a0a0a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Georgia", serif;
  padding: 40px 24px;
`;

const Box = styled.div`
  text-align: center;
  max-width: 480px;
  animation: ${fadeUp} 0.6s ease forwards;
`;

const Check = styled.div`
  font-size: 2.5rem;
  margin-bottom: 32px;
  opacity: 0.6;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 2rem;
  font-weight: 400;
  letter-spacing: 0.06em;
  margin: 0 0 16px 0;
`;

const Message = styled.p`
  color: #555;
  font-size: 0.88rem;
  line-height: 1.7;
  margin: 0 0 8px 0;
`;

const OrderId = styled.p`
  color: #333;
  font-size: 0.7rem;
  font-family: monospace;
  letter-spacing: 0.08em;
  margin: 0 0 48px 0;
`;

const Btn = styled.button`
  background: #fff;
  color: #0a0a0a;
  border: none;
  padding: 14px 36px;
  font-size: 0.72rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: "Georgia", serif;
  transition: background 0.2s;

  &:hover {
    background: #ddd;
  }
`;

const OrderSuccess = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  return (
    <Page>
      <Box>
        <Check>✓</Check>
        <Title>Order Placed</Title>
        <Message>
          Thank you for your order. We'll be in touch soon to confirm your
          shipment.
        </Message>
        <OrderId>Order #{orderId}</OrderId>
        <Btn onClick={() => navigate("/shop")}>Continue Shopping</Btn>
      </Box>
    </Page>
  );
};

export default OrderSuccess;
